let actx;

export function haptic(ms = 18) {
  try {
    if (navigator.vibrate) navigator.vibrate(ms);
  } catch (e) { /* ignore */ }
}

// Short, subtle incoming-message blip (rising sine).
export function blip() {
  haptic(18);
  try {
    actx = actx || new (window.AudioContext || window.webkitAudioContext)();
    if (actx.state === "suspended") actx.resume();
    const o = actx.createOscillator();
    const g = actx.createGain();
    const t = actx.currentTime;
    o.type = "sine";
    o.frequency.setValueAtTime(760, t);
    o.frequency.exponentialRampToValueAtTime(1280, t + 0.09);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.05, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.2);
    o.connect(g);
    g.connect(actx.destination);
    o.start(t);
    o.stop(t + 0.22);
  } catch (e) { /* ignore */ }
}

// Soft tap for sending.
export function tapSound() {
  haptic(10);
  try {
    actx = actx || new (window.AudioContext || window.webkitAudioContext)();
    if (actx.state === "suspended") actx.resume();
    const o = actx.createOscillator();
    const g = actx.createGain();
    const t = actx.currentTime;
    o.type = "triangle";
    o.frequency.setValueAtTime(420, t);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.03, t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.1);
    o.connect(g);
    g.connect(actx.destination);
    o.start(t);
    o.stop(t + 0.12);
  } catch (e) { /* ignore */ }
}
